<template>
  <v-dialog :value="dialog" persistent max-width="700">
    <v-card>
      <v-card-title class="text-h5"> Update Data View </v-card-title>

      <div class="px-5 my-5">
        <v-text-field
          label="Data View Name"
          placeholder="Data View Name"
          outlined
          v-model="data.name"
        ></v-text-field>
      </div>

      <div style="padding: 20px">
      <p class="text-h6 pt-4">Fields</p>
      <div>

        <v-row v-for="(item, i) in data.fields" :key="i" class="mb-1" dense>
          <v-col>
            <v-text-field
              outlined
              dense
              :value="item.name"
              @input="(val) => editDataView(`fields[${i}].name`, val)"
              label="Name"
            />
          </v-col>
          <v-col cols="auto">
            <v-btn icon @click="removeInput(i)">
              <v-icon color="error">mdi-delete</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-btn
          text
          :disabled="disableAddInput"
          @click="addInput"
          color="primary"
        >
          + Add Input
        </v-btn>

      </div>
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="() => { close() }"> Cancel </v-btn>
        <v-btn color="blue darken-1" text @click="saveDataView"> Save </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';

const {
  mapGetters: dataViewGetters,
  mapActions: dataViewActions,
  mapMutations: dataViewMutations,
} = createNamespacedHelpers('DataView');

import cloneDeep from 'lodash/cloneDeep';
import lodashSet from 'lodash/set';

export default {
  name: 'EditDataView',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: {
        fields: [],
        name: '',
      },
    };
  },
  watch: {
    'selectedCustomer.customer_id'() {},
    'dataView'() {
      this.data.fields = Object.keys(this.dataView.schema).map((field) => ({
        name: field
      }));
      this.data.name = this.dataView.name;
    }
  },
  computed: {
    ...dataViewGetters({
      dataView: 'EDIT_DATA_VIEW'
    }),
    disableAddInput() {
      const inputs = this.data.fields;
      if (!inputs) return true;
      if (!inputs[0]) return false;
      const lastInput = inputs[inputs.length - 1];
      return !lastInput?.name;
    },
  },
  mounted() {
    this.data.fields = Object.keys(this.dataView.schema).map((field) => ({
      name: field
    }));
    this.data.name = this.dataView.name;
  },
  methods: {
    ...dataViewActions(['updateDataView']),
    ...dataViewMutations({
      setEditDataView: 'EDIT_DATA_VIEW',
    }),
    async close() {
      this.setEditDataView(null);
      this.$emit('close')
    },
    async editDataView(prop, value) {
      const dataView = cloneDeep(this.data);
      lodashSet(dataView, prop, value);
      this.data = dataView;
    },
    removeInput(index) {
      this.data.fields.splice(index, 1);
    },
    addInput() {
      const inputs = cloneDeep(this.data.fields);
      inputs.push({ name: '' });
      this.data.fields = inputs;
    },
    async saveDataView() {
      let schema = {};
      this.data.fields.forEach(field => {
        schema[field.name] = '';
      })
      try {
        await this.updateDataView({
          id: this.dataView.id,
          schema: schema,
          name: this.data.name,
        });
        this.close();
      } catch (error) {
        console.log(error);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import 'edit-data-view-modal';
</style>
